module.exports = __webpack_public_path__ + "img/service-couple.260819d8.jpg";